import { render } from "./NotesComponent.vue?vue&type=template&id=c91d6580&scoped=true"
import script from "./NotesComponent.vue?vue&type=script&lang=js"
export * from "./NotesComponent.vue?vue&type=script&lang=js"

import "./NotesComponent.vue?vue&type=style&index=0&id=c91d6580&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c91d6580"]])

export default __exports__